import React from "react";
import { useField, useFormikContext } from "formik";
import { Checkbox, FieldHelperText, FieldLabel } from "@td/ui";
import { translate } from "@td/shared_utils";
import { fieldTypes } from "../../constants";
import { useProviderPanel } from "../../contexts/provider-panel-context";
import styles from "./styles.module.scss";

const NewPatientStatesField = React.memo(() => {
  const [{ value, ...field }, meta] = useField(fieldTypes.NEW_PATIENT_STATES);
  const { provider: { licenses }} = useProviderPanel();

  if (!licenses.length) {
    return (
      <div className={styles.fallbackMessage}>
        {translate(null, "provider_panel.form.fields.new_patient_states.errors", "no_active_licenses")}
      </div>
    );
  }

  const { values: { [fieldTypes.ACCEPT_NEW_PATIENTS]: acceptNewPatients }} = useFormikContext();

  return (
    <FieldLabel htmlFor="new-patient-states-field">
      <div>
        {translate(null, "provider_panel.form.fields.new_patient_states", "label")}
      </div>
      <div
        className={styles.content}
        data-testid="new-patient-states-checkbox-group"
      >
        {licenses.map(license => (
          <Checkbox
            {...field}
            key={license.stateCd}
            name={fieldTypes.NEW_PATIENT_STATES}
            onChange={field.onChange}
            value={license.stateCd}
            checked={value.includes(license.stateCd)}
            disabled={!acceptNewPatients}
            className={styles.checkbox}
            invalid={!!meta.error && meta.touched}
          >
            {license.stateCd}
          </Checkbox>
        ))}
      </div>
      <FieldHelperText error={!!meta.error && meta.touched}>
        {meta.error}
      </FieldHelperText>
    </FieldLabel>
  );
});

NewPatientStatesField.displayName = "NewPatientStatesField";

export default NewPatientStatesField;
